export default "__VITE_ASSET__3df1980f__"